import { render, staticRenderFns } from "./DeviceAlertParams.vue?vue&type=template&id=537d8cb8"
import script from "./DeviceAlertParams.vue?vue&type=script&lang=js"
export * from "./DeviceAlertParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports